<template>
  <div class="account-establish">
    <el-page-header @back="$router.go(-1)" content="账号搭建"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="搭建工具" name="1">
        <Establish />
      </el-tab-pane>
      <el-tab-pane label="成果展示" name="2">
        <Result ref="Result" />
      </el-tab-pane>
      <el-tab-pane label="评价窗口" name="3" lazy>
        <Evaluate category="dj" />
      </el-tab-pane>
      <el-tab-pane label="英雄榜" name="4" lazy>
        <Ranking category="dj" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Establish from "./establish.vue";
import Evaluate from "../evaluate.vue";
import Ranking from "../ranking.vue";
import Result from "./result.vue";
export default {
  components: { Establish, Result, Evaluate, Ranking },
  data() {
    return {
      activeName: "1",
    };
  },
  watch: {
    activeName(val) {
      if (val == "2") this.$refs.Result.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.account-establish {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>